<template>
  <div id="screen" class="ui center aligned basic segment" style="overflow:auto;display:flex;margin:0">
    <div class="ui center aligned container purple segment" style="display:inline-block;margin:auto">
      <h3 class="header">Check vehicle out</h3>
      <div class="ui left aligned basic segment">
        <form class="ui form" id="insform" @submit="onOLFormSubmit">
          <div class="field" id="locationcntr">
            <label>Location:</label>
            <select id="locationselector" name="location" v-model="selectedlocation" class="ui dropdown" required>
              <option value="-1"></option>
              <option v-for="(loc,index) in this.$locations" :key="index" :value="loc.id">{{ loc.companyname }}</option>
            </select>
          </div>
          <div class="field">
            <label>Vehicle OUT registration: 
              <button class="ui tiny purple button" style="padding:.5rem 1rem .5rem 1rem" @click="startScanPlate" v-if="online" :class="{loading:recognisingPlate,disabled:recognisingPlate}">scan plate</button></label>
            <input type="text" name="reg" required v-model="reg" @change="validateForm">
          </div>
          <div class="field" v-if="this.drivers && this.drivers.length>0">
            <label>Parson taking vehicle:</label>
            <input type="text" v-model="driverterms" @change="filterDrivers()" placeholder="Search for driver here">
            <select class="ui search selection dropdown" id="driverselector" v-model="selectedDriver" name="selectedperson">
              <option data-display="Select Driver">-</option>
              <option v-for="(driver, index) in this.fdrivers" :key="index" :value="driver.id">{{ driver.firstname + ' ' +driver.lastname + ' ('+driver.drivinglicenseno+')' }}</option>
            </select>
          </div>
          <div class="field" v-if="!(this.drivers && this.drivers.length>0)">
            <label>Person taking vehicle:</label>
            <input type="text" v-model="personname" name="personname" placeholder="Full name" @change="validateForm" required>
          </div>
          <div class="field" id="targetarea">
            <label>New area:</label>
            <select id="areaselector" name="area" v-model="selectedarea" class="ui dropdown" required>
              <option value="-1"></option>
              <option v-for="(loc,index) in this.$areas" :key="index" :value="loc.id">{{ loc.name }}</option>
            </select>
          </div>
          <div class="field">
            <label>Reason:</label>
            <textarea v-model="reason" name="reason" placeholder="Enter the reason why this vehicle is checking out" @change="validateForm"></textarea>
          </div>
          <div class="field" style="margin-top:3em">
            <input type="submit" value="Check out" :class="{disabled:!isFormOkay}" class="ui primary button">
          </div>
        </form>
      </div>
    </div>
  </div>

  <div id="modalcontainer">

    <PlatecameraModal v-if="showPlateCamera" :class="{active:showPlateCamera}" @newPicture="onNewPlateImage" @error="onNewPlateError" @closed="onPlateCameraModalClosed"/>
    
  </div>
</template>

<style>
  .ui.fluid.dropdown.hidden {
    display:none;
  }
</style>

<script>

import PlatecameraModal from '@/components/PlatecameraModal.vue'

  function diff (num1, num2) {
    if (num1 > num2) {
      return num1 - num2
    } else {
      return num2 - num1
    }
  }

  export default {
    data() {
      return {
        selectedDriver:null,
        drivers:[],
        fdrivers:[],
        personname:'',
        reason:'',
        showPlateCamera:false,
        recognisingPlate:false,
        online: true,
        selectedlocation:-1,
        selectedarea:-1,
        plateimage:null,
        reg:this.$route.query.reg || '',
        isFormOkay:false,
        isswap:this.$route.query.isswap || false,
        vcin:this.$route.query.vcin || null
      }
    },
    components: {
      PlatecameraModal
    },
    methods: {
      filterDrivers() {
        var terms = this.driverterms;
        var ta=[];

        for (var i=0; i< this.drivers.length; i++) {
          if ((this.drivers[i].firstname + ' ' + this.drivers[i].lastname).toLowerCase().indexOf(terms.trim().toLowerCase()) > -1) {
            ta.push(this.drivers[i]);
          }
        }
        this.fdrivers = ta;
      },
      validateForm() {
        var reg = this.reg.replace(/ /g, '');

        this.isFormOkay=true;

        if (reg.length != 7) {
          this.isFormOkay=false;
          return;
        }

        if (this.personname.length < 5 && !(this.drivers && this.drivers.length>0)) {
          this.isFormOkay=false;
          return;
        }

        if (this.drivers && this.drivers.length>0 && !this.selectedDriver) {
          this.isFormOkay=false;
          return;
        }

        if (this.reason.length < 5) {
          this.isFormOkay=false;
          return;
        }
      },
      onPlateCameraModalClosed() {
        document.getElementById('modalcontainer').style.display='none';
        this.showPlateCamera = false;
      },
      recognisePlate(imagedata) {
        var thiz = this;

        //console.log('recognisePlate');

        if (navigator.onLine) {
          //console.log('recognisePlats online');
          fetch(this.$host+'/recognise', {
            method:'POST',
            mode:'cors',
            credentials:'include',
            headers:{'Content-type':'application/json'},
            body:JSON.stringify({img:imagedata, i:0, location:this.selectedlocation})
          }).then(res=>res.json()).then(res=>{
            this.recognisingPlate = false;
            if (res.error){
              console.log('application error #274', res);
            }
            else {
              console.log(res);
              if (res && res.res && res.res.results && res.res.results.length>0) {
                thiz.reg = res.res.results[0].plate.toUpperCase();
              }
              else {
                thiz.reg = '';
              }
              console.log(thiz.reg);
            }
          }).catch(err=>{
            console.log('system error #273', err);
          });
        }
        else {
          //console.log('recognisePlate offline');
          setTimeout(()=>{thiz.recognisePlate(imagedata)},5000);
        }
      },
      onNewPlateImage(data) {
        //console.log(data);
        this.recognisingPlate = true;
        this.recognisePlate(data);
      },
      onNewPlateError(err) {
        console.log(err);
      },
      startScanPlate(e) {
        // show camera view
        // start camera
        if (e) e.preventDefault();
        console.log('startScanPlate', e);

        document.getElementById('modalcontainer').style.display='flex';
        this.showPlateCamera = true;
      },
      onOLFormSubmit(e) {
        if (e) e.preventDefault();

        var myFormData = new FormData(document.getElementById('insform'));
        var formDataObj = {};
        myFormData.forEach((value, key) => {
          formDataObj[key] = value;
        });
        console.log('insform submitted',formDataObj);
       
          var id = Date.now();

          localStorage.setItem('vout'+id, JSON.stringify(formDataObj));
          
          this.clearForm();
          this.$router.push({path:'/offlineinspection', query:{vcin:this.vcin, vcout:id, isswap:this.isswap, reg:this.reg, location:this.selectedlocation}});
      },
      getLocation() {
        var thiz = this;
        if(navigator.geolocation) {
            navigator.geolocation.getCurrentPosition((event) =>{
              var i,a,o,op=-1,od,nd;
              
              for (i=0; i< thiz.$locations.length; i++) {
                if (!(thiz.$locations[i].lat)) {
                  continue;
                }

                if (op === -1) {
                  op = i;
                  a = diff(event.coords.latitude, thiz.$locations[i].lat);
                  o = diff(event.coords.longitude, thiz.$locations[i].lon);

                  od = a*a+o*o;
                }
                else {
                  a = diff(event.coords.latitude, thiz.$locations[i].lat);
                  o = diff(event.coords.longitude, thiz.$locations[i].lon);
                  nd = a*a+o*o;

                  if (nd < od) {
                    od=nd;
                    op = i;
                  }
                }
              }
              thiz.selectedlocation = thiz.$locations[op].id;

            },(e)=>{
              console.log(e);
            },{enableHighAccuracy:true}
          );
        } else {
            alert("Your browser doesn't support Geolocation");
        }
      },
      clearForm() {
        document.getElementById('insform').reset();
      },
      setOnline() {
        this.online = true;
      },
      setOffline() {
        this.online=false;
      }
    },
    mounted() {
      var thiz = this;

      this.getLocation();

      window.addEventListener('online', thiz.setOnline);
      window.addEventListener('offline', thiz.setOffline);

      setTimeout(()=>{
        const e = document.querySelector('#purpleheader').animate({height:"130px"}, 500)
        e.onfinish = ()=>{
          document.querySelector('#purpleheader').style.height = "130px";
        };
      },0);

      // load drivers
      fetch(this.$host + '/drivers2una34ahg6', {method:'GET', mode:'cors'}).then(res=>res.json()).then(res=>{
        if (res.error) {
          thiz.usetextfield=true;
        }
        else {
          thiz.usetextfield=false;
          res.drivers.sort((a,b)=>{
            if (a.lastname.trim()>b.lastname.trim()) {
              return 1;
            }
            if (a.lastname.trim() === b.lastname.trim()) {
              if (a.firstname.trim() >b.firstname.trim()) {
                return 1;
              }
            }
            return -1;
          });
          thiz.drivers = res.drivers;
          thiz.filterDrivers();
        }
      });
    },
    beforeUnmount() {
      window.removeEventListener('online', this.setOnline);
      window.removeEventListener('offline', this.setOffline);
    }
  }

</script>
